(() => {
  const menu = document.querySelector('[data-mobile-menu]');
  const toggle = document.querySelector('[data-menu-toggle]');
  const close = document.querySelector('[data-menu-close]');

  const setMenu = (open) => {
    if (!menu || !toggle) return;
    menu.hidden = !open;
    toggle.setAttribute('aria-expanded', String(open));
    document.body.classList.toggle('menu-open', open);
    if (open) close?.focus();
  };
  toggle?.addEventListener('click', () => setMenu(true));
  close?.addEventListener('click', () => setMenu(false));
  menu?.querySelectorAll('a').forEach((link) => {
    link.addEventListener('click', () => setMenu(false));
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && menu && !menu.hidden) setMenu(false);
  });

  document.querySelectorAll('[data-gallery]').forEach((gallery) => {
    const media = [...gallery.querySelectorAll('[data-media-index]')];
    const dots = [...gallery.querySelectorAll('[data-gallery-dot]')];
    const previous = gallery.querySelector('[data-gallery-prev]');
    const next = gallery.querySelector('[data-gallery-next]');
    const autoplayDelay = Number(gallery.dataset.galleryAutoplay) || 0;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let activeIndex = 0;
    let autoplayTimer;

    const setActive = (index) => {
      activeIndex = (index + media.length) % media.length;
      const key = String(activeIndex);
      media.forEach((item) => {
        const isActive = item.dataset.mediaIndex === key;
        item.classList.toggle('is-active', isActive);
        item.setAttribute('aria-hidden', String(!isActive));
      });
      dots.forEach((item) => {
        item.classList.remove('is-active');
        item.removeAttribute('aria-current');
      });
      const activeDot = dots.find((item) => item.dataset.galleryDot === key);
      if (activeDot) {
        void activeDot.offsetWidth;
        activeDot.classList.add('is-active');
        activeDot.setAttribute('aria-current', 'true');
      }
    };

    const stopAutoplay = () => {
      window.clearTimeout(autoplayTimer);
      gallery.classList.add('is-paused');
    };
    const startAutoplay = () => {
      window.clearTimeout(autoplayTimer);
      gallery.classList.remove('is-paused');
      if (!autoplayDelay || reduceMotion || document.hidden || media.length < 2) return;
      autoplayTimer = window.setTimeout(() => {
        setActive(activeIndex + 1);
        startAutoplay();
      }, autoplayDelay);
    };
    const navigate = (index) => {
      setActive(index);
      startAutoplay();
    };

    dots.forEach((dot) => dot.addEventListener('click', () => navigate(Number(dot.dataset.galleryDot))));
    previous?.addEventListener('click', () => navigate(activeIndex - 1));
    next?.addEventListener('click', () => navigate(activeIndex + 1));
    let touchStartX = 0;
    gallery.addEventListener('touchstart', (event) => {
      touchStartX = event.changedTouches[0]?.clientX || 0;
      stopAutoplay();
    }, { passive: true });
    gallery.addEventListener('touchend', (event) => {
      const touchEndX = event.changedTouches[0]?.clientX || touchStartX;
      const distance = touchEndX - touchStartX;
      if (Math.abs(distance) > 45) navigate(activeIndex + (distance < 0 ? 1 : -1));
      else startAutoplay();
    }, { passive: true });
    gallery.addEventListener('focusin', stopAutoplay);
    gallery.addEventListener('focusout', (event) => {
      if (!gallery.contains(event.relatedTarget)) startAutoplay();
    });
    document.addEventListener('visibilitychange', () => document.hidden ? stopAutoplay() : startAutoplay());

    media.forEach((item, index) => item.setAttribute('aria-hidden', String(index !== 0)));
    dots[0]?.setAttribute('aria-current', 'true');
    startAutoplay();
  });

  document.querySelectorAll('[data-product-root]').forEach((root) => {
    const form = root.querySelector('.oura-product-form');
    const json = root.querySelector('[data-product-variants]');
    if (!form || !json) return;
    const variants = JSON.parse(json.textContent || '[]');
    const idInput = form.querySelector('[data-variant-id]');
    const price = root.querySelector('[data-product-price]');
    const mobilePrice = document.querySelector('[data-mobile-price]');
    const submit = form.querySelector('[data-add-to-cart]');
    const moneyFormat = window.Shopify?.currency?.active || '';
    const shopifyRoot = window.Shopify?.routes?.root || '/';
    const bundleGroup = root.querySelector('[data-bundle-group]');
    const bundleOptions = [...(bundleGroup?.querySelectorAll('[data-bundle-option]') || [])];
    const quantityPicker = form.querySelector('[data-quantity-picker]');
    const quantityInput = form.querySelector('[data-quantity-input]');
    const quantityTrigger = quantityPicker?.querySelector('[data-quantity-trigger]');
    const quantityMenu = quantityPicker?.querySelector('[data-quantity-menu]');
    const quantityValue = quantityPicker?.querySelector('[data-quantity-value]');
    const quantityOptions = [...(quantityPicker?.querySelectorAll('[data-quantity-option]') || [])];

    const closeQuantityMenu = (restoreFocus = false) => {
      if (!quantityPicker || !quantityTrigger || !quantityMenu) return;
      quantityMenu.hidden = true;
      quantityPicker.classList.remove('is-open');
      quantityTrigger.setAttribute('aria-expanded', 'false');
      if (restoreFocus) quantityTrigger.focus();
    };

    const openQuantityMenu = () => {
      if (!quantityPicker || !quantityTrigger || !quantityMenu) return;
      quantityMenu.hidden = false;
      quantityPicker.classList.add('is-open');
      quantityTrigger.setAttribute('aria-expanded', 'true');
    };

    const formatMoney = (cents) => new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: moneyFormat || 'USD',
      minimumFractionDigits: cents % 100 === 0 ? 0 : 2
    }).format(cents / 100);

    const currentVariant = () => variants.find((item) => String(item.id) === String(idInput.value));

    const mobileTitle = document.querySelector('[data-mobile-title]');
    const mobileTitleDefault = mobileTitle?.textContent || '';

    const syncBundle = (quantity) => {
      const value = String(quantity);
      bundleOptions.forEach((option) => {
        const selected = option.dataset.bundleOption === value;
        option.classList.toggle('is-selected', selected);
        option.setAttribute('aria-pressed', String(selected));
      });
      const variant = currentVariant();
      if (!variant) return;
      const units = Number(value) === 3 ? 2 : Number(value) || 1;
      const total = formatMoney(variant.price * units);
      if (mobilePrice) mobilePrice.textContent = total;
      if (mobileTitle) mobileTitle.textContent = Number(value) === 3 ? 'Three-box set' : mobileTitleDefault;
      if (!submit || submit.disabled) return;
      submit.textContent = `Add to cart — ${total}`;
    };

    const selectQuantity = (nextValue) => {
      const value = String(nextValue);
      if (quantityInput) quantityInput.value = value;
      if (quantityValue) quantityValue.textContent = value;
      quantityOptions.forEach((option) => option.setAttribute('aria-selected', String(option.dataset.quantityOption === value)));
      syncBundle(value);
      closeQuantityMenu(true);
    };

    bundleOptions.forEach((option) => option.addEventListener('click', () => {
      if (quantityInput) quantityInput.value = option.dataset.bundleOption;
      if (quantityValue) quantityValue.textContent = option.dataset.bundleOption;
      quantityOptions.forEach((item) => item.setAttribute('aria-selected', String(item.dataset.quantityOption === option.dataset.bundleOption)));
      syncBundle(option.dataset.bundleOption);
    }));

    quantityTrigger?.addEventListener('click', () => {
      if (quantityMenu?.hidden) openQuantityMenu();
      else closeQuantityMenu();
    });
    quantityTrigger?.addEventListener('keydown', (event) => {
      if (!['ArrowDown', 'ArrowUp'].includes(event.key)) return;
      event.preventDefault();
      openQuantityMenu();
      const selectedIndex = Math.max(0, quantityOptions.findIndex((option) => option.getAttribute('aria-selected') === 'true'));
      quantityOptions[selectedIndex]?.focus();
    });
    quantityOptions.forEach((option, index) => {
      option.addEventListener('click', () => selectQuantity(option.dataset.quantityOption));
      option.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          event.preventDefault();
          closeQuantityMenu(true);
          return;
        }
        if (!['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        let nextIndex = index;
        if (event.key === 'ArrowDown') nextIndex = (index + 1) % quantityOptions.length;
        if (event.key === 'ArrowUp') nextIndex = (index - 1 + quantityOptions.length) % quantityOptions.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = quantityOptions.length - 1;
        quantityOptions[nextIndex]?.focus();
      });
    });
    document.addEventListener('click', (event) => {
      if (quantityPicker && !quantityPicker.contains(event.target)) closeQuantityMenu();
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && quantityMenu && !quantityMenu.hidden) closeQuantityMenu(true);
    });

    const refreshCartCount = async () => {
      const response = await fetch(`${shopifyRoot}cart.js`, { headers: { Accept: 'application/json' } });
      if (!response.ok) return;
      const cart = await response.json();
      document.querySelectorAll('.cart-link > span').forEach((count) => { count.textContent = cart.item_count; });
    };

    const updateVariant = () => {
      const selected = [...form.querySelectorAll('.product-option')].map((group) => {
        const checked = group.querySelector('input:checked');
        group.querySelector('[data-option-value]').textContent = checked?.value || '';
        return checked?.value;
      });
      const variant = variants.find((item) => item.options.every((value, index) => value === selected[index]));
      if (!variant) return;
      idInput.value = variant.id;
      const formatted = new Intl.NumberFormat(undefined, { style: 'currency', currency: moneyFormat || 'USD' }).format(variant.price / 100);
      if (price) price.textContent = formatted;
      if (mobilePrice) mobilePrice.textContent = formatted;
      submit.disabled = !variant.available;
      submit.textContent = variant.available ? 'Add to cart' : 'Sold out';
      if (variant.available) syncBundle(quantityInput?.value || 1);
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    };
    form.querySelectorAll('.product-option input').forEach((input) => input.addEventListener('change', updateVariant));

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (submit.disabled) return;
      const originalLabel = submit.textContent;
      submit.disabled = true;
      submit.textContent = 'Adding…';
      try {
        const response = await fetch(`${shopifyRoot}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        });
        if (!response.ok) throw new Error('Unable to add Routine Box to the cart.');
        await refreshCartCount();
        window.location.href = `${shopifyRoot}cart`;
      } catch (error) {
        submit.textContent = error.message;
        window.setTimeout(() => { submit.textContent = originalLabel; }, 2400);
        submit.disabled = false;
      }
    });

    syncBundle(quantityInput?.value || 1);

    const buyBarAnchor = submit;
    if (buyBarAnchor && 'IntersectionObserver' in window) {
      const barObserver = new IntersectionObserver(([entry]) => {
        document.body.classList.toggle('buybar-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      }, { threshold: 0 });
      barObserver.observe(buyBarAnchor);
    }
  });

  const reduceMotionGlobal = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!reduceMotionGlobal && 'IntersectionObserver' in window) {
    const revealTargets = document.querySelectorAll('.pdp-life article, .pdp-contrast__inner, .pdp-system__layout, .pdp-doctor__inner, .pdp-handoff, .pdp-specs__layout, .campaign-card, .campaign-system__grid, .campaign-clinic, .campaign-specs');
    const revealObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-revealed');
        revealObserver.unobserve(entry.target);
      });
    }, { threshold: 0.14 });
    revealTargets.forEach((element) => {
      const rect = element.getBoundingClientRect();
      const inInitialView = rect.top < window.innerHeight * 0.92 && rect.bottom > 0;
      if (inInitialView) return;
      element.classList.add('reveal-init');
      revealObserver.observe(element);
    });
  }

  document.querySelectorAll('[data-cart-group]').forEach((group) => {
    const input = group.querySelector('[data-cart-quantity-input]');
    const minus = group.querySelector('[data-cart-quantity-minus]');
    const plus = group.querySelector('[data-cart-quantity-plus]');
    const remove = group.querySelector('[data-cart-group-remove]');
    const status = group.querySelector('[data-cart-status]');
    const variantId = Number(group.dataset.variantId);
    const lineKeys = [...group.querySelectorAll('[data-cart-line-key]')]
      .map((item) => item.dataset.cartLineKey)
      .filter(Boolean);
    const shopifyRoot = window.Shopify?.routes?.root || '/';
    let updating = false;

    const setBusy = (busy) => {
      updating = busy;
      group.classList.toggle('is-updating', busy);
      [minus, plus, remove].forEach((button) => { if (button) button.disabled = busy; });
    };

    const replaceQuantity = async (nextQuantity) => {
      if (updating || !variantId || !lineKeys.length) return;
      const quantity = Math.max(0, Math.min(20, Number(nextQuantity) || 0));
      setBusy(true);
      if (status) status.textContent = quantity ? 'Updating your cart…' : 'Removing Routine Box…';

      try {
        const updates = Object.fromEntries(lineKeys.map((key) => [key, 0]));
        const removeResponse = await fetch(`${shopifyRoot}cart/update.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates })
        });
        if (!removeResponse.ok) throw new Error('Your cart could not be updated. Please try again.');

        if (quantity > 0) {
          const addResponse = await fetch(`${shopifyRoot}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: variantId, quantity }] })
          });
          if (!addResponse.ok) throw new Error('Your cart could not be updated. Please try again.');
        }

        window.location.reload();
      } catch (error) {
        if (status) status.textContent = error.message;
        setBusy(false);
      }
    };

    minus?.addEventListener('click', () => replaceQuantity(Number(input?.value || 0) - 1));
    plus?.addEventListener('click', () => replaceQuantity(Number(input?.value || 0) + 1));
    remove?.addEventListener('click', () => replaceQuantity(0));
  });
})();
